import React from 'react';
import {
    BooleanInput,
    DateField,
    DisabledInput,
    Edit,
    FormTab,
    FunctionField,
    ReferenceField,
    TabbedForm,
    CardActions,
    ShowButton,
    Labeled,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import ExternalUrlField from '../inputs/ExternalUrlField';
import ApproveButton from '../actions/ApproveButton';
import UndeleteButton from '../actions/UndeleteButton';

const PostTitle = ({ record }) => {
    return <span>Thread { record ? `"${record.thread}" - Post ${record.id}` : '' }</span>
};

const PostEditActions = ({ basePath, data, record }) => {
    console.log(data);
    console.log({data});
    return(
    <CardActions>
        <ShowButton basePath={basePath} record={data}/>
        {(data && data.approved_at === null && data.deleted_at === null) &&
        <ApproveButton record={data}/>
        }
        {(data && data.deleted_at !== null) &&
        <UndeleteButton record={data}/>
        }
    </CardActions>
    )
};

const ConditionalNotNullDeletedField = ({ record, ...rest },) => (
    record && record.deleted_at != null
        ? <Labeled label="Deleted"><DateField source="deleted_at" record={record} {...rest} showTime/></Labeled>
        : null
);
const ConditionalNotNullApprovedField = ({ record, ...rest },) => (
    record && record.approved_at != null
        ? <Labeled label="Approved"><DateField source="approved_at" record={record} {...rest} showTime/></Labeled>
        : null
);

export const PostEdit = (props) => (
    <Edit title={<PostTitle />} actions={<PostEditActions />} {...props}>
        <TabbedForm >
            <FormTab label="Post">
                <ReferenceField label="Link to Thread" reference="threads" source="thread" linkType={false}>
                    <ExternalUrlField source="link" />
                </ReferenceField>
                <FunctionField label="ID" render={record => `${record.id.replace(/\/posts\//, '')}`} />
                <DisabledInput source="thread" />
                <DisabledInput source="parent" />
                <DisabledInput source="user" />
                <ConditionalNotNullApprovedField />
                <BooleanInput label="Needs Review?" source="needs_review" />
                <BooleanInput label="Is Spam?" source="spam" />
                <BooleanInput label="Has Profanity?" source="profanity" />
                <BooleanInput label="Has Links?" source="links" />
                <DateField disabled label="Updated" source="updated_at" showTime />
                <DateField disabled label="Created" source="created_at" showTime />
                <ConditionalNotNullDeletedField />

            </FormTab>
            <FormTab label="Message" path="message">
                <RichTextInput source="message" />
            </FormTab>
        </TabbedForm>
    </Edit>
)
